import camelcase from 'lodash.camelcase'

import { ACORNS_HELLO_FLOW, VISITED_PAGES } from 'app-constants'
import { MOC_ONBOARDING_FLOW } from 'app-constants'
import { LinkedAccount, LinkedAccountExternalSourceEnum } from 'generated/types'
import { sendToSentry } from 'utils/errors'
import { NavSteps as CoreNavSteps } from 'utils/FlowProvider/flows/core/nav'
import { NavSteps as DirectToMobile } from 'utils/FlowProvider/flows/directToMobile/nav'
import { NavSteps as LaterNavSteps } from 'utils/FlowProvider/flows/later/nav'
import { NavSteps as LaterOnboardingNavSteps } from 'utils/FlowProvider/flows/laterOnboarding/nav'
import { NavSteps as MightyOakCardOnboardingSteps } from 'utils/FlowProvider/flows/mightyOakCardOnboarding/nav'
import { NavSteps as SpendNavSteps } from 'utils/FlowProvider/flows/spend/nav'
import { NavSteps as TieredNavSteps } from 'utils/FlowProvider/flows/tiered/nav'
import removeDuplicateQueryParams from 'utils/sourceAttributes'

import { FlowRoute } from './types'

export const navStepMap = new Map([
  ['later', LaterNavSteps],
  ['laterOnboarding', LaterOnboardingNavSteps],
  ['spend', SpendNavSteps],
  ['core', CoreNavSteps],
  ['tiered', TieredNavSteps],
  ['directToMobile', DirectToMobile],
  ['mightyOakCardOnboarding', MightyOakCardOnboardingSteps],
])

export const getDefaultFlow = (): string => 'tiered'

// Returns boolean for for if the user is in the default flow
export const isDefaultFlow = (): boolean => {
  return (
    getFlow() === 'core' ||
    getFlow() === 'tiered' ||
    getFlow() === 'directToMobile' ||
    getFlow() === MOC_ONBOARDING_FLOW
  )
}

export const getValidFlow = flow => {
  if (
    String(flow).match(
      /^(core|later|laterOnboarding|spend|tiered|directToMobile|mightyOakCardOnboarding)$/,
    )
  ) {
    return flow
  } else {
    return getDefaultFlow()
  }
}

// Gets the flow for the current user. If not in the query string, checks the sessionStorage or uses 'tiered' by default
export const getFlow: () => string = () => {
  let flow
  try {
    const parsed = removeDuplicateQueryParams(window.location.search)
    if (parsed.flow) {
      flow = getValidFlow(camelcase(parsed.flow))
    } else if (window.localStorage.getItem(ACORNS_HELLO_FLOW)) {
      flow = getValidFlow(window.localStorage.getItem(ACORNS_HELLO_FLOW))
    } else {
      flow = getDefaultFlow()
    }
    window.localStorage.setItem(ACORNS_HELLO_FLOW, flow)
  } catch (e) {
    sendToSentry(e, {
      name: 'FlowProviderError',
      message: 'Cannot resolve flow. Using default flow instead.',
    })
    flow = getDefaultFlow()
  }
  return flow
}

export const getFunnelName = flowName => {
  switch (flowName) {
    case 'later':
      return 'core_later'
    case 'spend':
      return 'core_spend'
    case 'laterOnboarding':
      return 'laterOnboarding'
    case 'tiered':
      return 'tiered_reg'
    case 'directToMobile':
      return 'direct_to_mobile'
    case 'mightyOakCardOnboarding':
      return 'mightyOakCardOnboarding'
    default:
      return 'core'
  }
}

const investingPages = [
  FlowRoute.RecurringInvestment,
  FlowRoute.OneTimeInvestment,
  FlowRoute.SecondChanceBankLink,
]

export const investingPageVisited = visitedPages => {
  const visited = investingPages.some(page => visitedPages.includes(page))
  return visited
}

export const getVisitedPages = () => {
  return JSON.parse(window.localStorage.getItem(VISITED_PAGES) || '[]')
}

export const checkIsEligibleRoundUps = (linkedAccounts: LinkedAccount[]) => {
  let isEligibleRoundUps = false

  if (linkedAccounts) {
    for (const linkedAccount of linkedAccounts) {
      if (
        linkedAccount?.externalSource === LinkedAccountExternalSourceEnum.Spend ||
        linkedAccount.externalSource === LinkedAccountExternalSourceEnum.DirectBank ||
        linkedAccount.externalSource === LinkedAccountExternalSourceEnum.Plaid
      ) {
        isEligibleRoundUps = true
      }
    }
  }
  return isEligibleRoundUps
}
